export const CPF_MASK = {
  mask: "000.000.000-00",
  clearIfNotMatch: true,
};

export const PASSAPORT_MASK = {
  mask: "AAAAAAAAAAAAAAAAAAAAAAAAAAAA",
};
